export const trigSurvey = event => {
  window._kiq?.push([
    'set',
    {
      clicked_button: event
    }
  ]);
};
